<template>
  <div>
    <navMenu />
    
    <hero :heroTitle="$t('footer.pp')" :heroSubtitle="$t('ppPage.subtitle')"  />


    <section class="jsk-block pt-0">
      <div class="container">
        <div class="row">
          <div class="col-12 col-md-12">
            <p>
              {{ $t('ppPage.preambuleP[0]') }}
            </p>
            <p>
              {{ $t('ppPage.preambuleP[1]') }}
            </p>
            <p>
              {{ $t('ppPage.preambuleP[2]') }}
            </p>
            <p>
              {{ $t('ppPage.preambuleP[3]') }}
            </p>

            <h4 class="mt-5 text-uppercase">{{ $t('ppPage.oneTitle') }}</h4>
            <h5>{{ $t('ppPage.oneOneTitle') }}</h5>
             <p>
              {{ $t('ppPage.oneOneP[0]') }}
            </p>
             <p>
              {{ $t('ppPage.oneOneP[1]') }}
            </p>
             <p>
              {{ $t('ppPage.oneOneP[2]') }}
            </p>
            <p>
              {{ $t('ppPage.oneOneP[3]') }}
            </p>
             <p>
              {{ $t('ppPage.oneOneP[4]') }}
            </p>
             <p>
              {{ $t('ppPage.oneOneP[5]') }}
            </p>
            <p>
              {{ $t('ppPage.oneOneP[6]') }}
            </p>

            <h5 class="mt-5">{{ $t('ppPage.oneTwoTitle') }}</h5>
            <p>
              {{ $t('ppPage.oneTwoP[0]') }}
            </p>
             <p>
              {{ $t('ppPage.oneTwoP[1]') }}
            </p>
             <p>
              {{ $t('ppPage.oneTwoP[2]') }}
            </p>
             <p>
              {{ $t('ppPage.oneTwoP[3]') }}
            </p>
            <p>
              {{ $t('ppPage.oneTwoP[4]') }}
            </p>

            <h5 class="mt-5">{{ $t('ppPage.oneThreeTitle') }}</h5>
            <p>
              {{ $t('ppPage.oneThreeP') }}
            </p>

             <h5 class="mt-5">{{ $t('ppPage.oneFourTitle') }}</h5>
             <p>
              {{ $t('ppPage.oneFourP[0]') }}
            </p>
            <p>
              {{ $t('ppPage.oneFourP[1]') }}
            </p>
            <p>
              {{ $t('ppPage.oneFourP[2]') }}
            </p>

             <h5 class="mt-5">{{ $t('ppPage.oneFiveTitle') }}</h5>
              <p>
              {{ $t('ppPage.oneFiveP[0]') }}
            </p>
            <p>
              {{ $t('ppPage.oneFiveP[1]') }}
            </p>

            <h4 class="mt-5 text-uppercase">{{ $t('ppPage.twoTitle') }}</h4>
            <h5>{{ $t('ppPage.twoOneTitle') }}</h5>
            <p>
              {{ $t('ppPage.twoOneP') }}
            </p>

            <h5 class="mt-5">{{ $t('ppPage.twoTwoTitle') }}</h5>
            <p>
              {{ $t('ppPage.twoTwoP') }}
            </p>

            <h5 class="mt-5">{{ $t('ppPage.twoThreeTitle') }}</h5>
            <p>
              {{ $t('ppPage.twoThreeP[0]') }}
            </p>
            <p>
              {{ $t('ppPage.twoThreeP[1]') }}
            </p>

            <h5 class="mt-5">{{ $t('ppPage.twoFourTitle') }}</h5>
            <p>
              {{ $t('ppPage.twoFourP[0]') }}
            </p>
            <p>
              {{ $t('ppPage.twoFourP[1]') }}
            </p>
            <p>
              {{ $t('ppPage.twoFourP[2]') }}
            </p>

            <h4 class="mt-5 text-uppercase">{{ $t('ppPage.threeTitle') }}</h4>
            <p>
              {{ $t('ppPage.threeP[0]') }}
            </p>
            <p>
              {{ $t('ppPage.threeP[1]') }}
            </p>
            <p>
              {{ $t('ppPage.threeP[2]') }}
            </p>
            <p>
              {{ $t('ppPage.threeP[3]') }}
            </p>
            <p>
              {{ $t('ppPage.threeP[4]') }}
            </p>

            <h4 class="mt-5 text-uppercase">{{ $t('ppPage.fourTitle') }}</h4>
            <p>
              {{ $t('ppPage.fourP') }}
            </p>

            <h4 class="mt-5 text-uppercase">{{ $t('ppPage.fiveTitle') }}</h4>
            <p>
              {{ $t('ppPage.fiveP') }}
            </p>

            <h4 class="mt-5 text-uppercase">{{ $t('ppPage.sixTitle') }}</h4>
            <p>
              {{ $t('ppPage.sixP[0]') }}
            </p>
            <p>
              {{ $t('ppPage.sixP[1]') }}
            </p>

            <h4 class="mt-5 text-uppercase">{{ $t('ppPage.sevenTitle') }}</h4>
            <p>
              {{ $t('ppPage.sevenP[0]') }}
            </p>

            <table>
              <tbody>
                <tr>
                  <td>
                    <p>{{ $t('ppPage.sevenTableRows[0]') }}</p>
                  </td>
                  <td>
                    <p>{{ $t('ppPage.sevenTableRows[1]') }}</p>
                  </td>
                </tr>
                <tr>
                  <td>
                    <p>{{ $t('ppPage.sevenTableRows[2]') }}</p>
                  </td>
                  <td>
                    <p>{{ $t('ppPage.sevenTableRows[3]') }}</p>
                  </td>
                </tr>
                <tr>
                  <td>
                    <p>{{ $t('ppPage.sevenTableRows[4]') }}</p>
                  </td>
                  <td>
                    <p>{{ $t('ppPage.sevenTableRows[5]') }}</p>
                  </td>
                </tr>
                <tr>
                  <td>
                    <p>{{ $t('ppPage.sevenTableRows[6]') }}</p>
                  </td>
                  <td>
                    <p>{{ $t('ppPage.sevenTableRows[7]') }}</p>
                  </td>
                </tr>
              </tbody>
            </table>
            <p>
              {{ $t('ppPage.sevenP[1]') }}
            </p>
            <p>
              {{ $t('ppPage.sevenP[2]') }}
            </p>

            <h4 class="mt-5 text-uppercase">{{ $t('ppPage.eightTitle') }}</h4>
            <p>
              {{ $t('ppPage.eightP') }}
            </p>

            <h4 class="mt-5 text-uppercase">{{ $t('ppPage.nineTitle') }}</h4>
            <p>
              {{ $t('ppPage.nineP') }}
            </p>

            <h4 class="mt-5 text-uppercase">{{ $t('ppPage.tenTitle') }}</h4>
            <h5>{{ $t('ppPage.tenOneTitle') }}</h5>
            <p>
              {{ $t('ppPage.tenOneP[0]') }}
            </p>
            <p>
              {{ $t('ppPage.tenOneP[1]') }}
            </p>
            <p>
              {{ $t('ppPage.tenOneP[2]') }}
            </p>
            <p>
              {{ $t('ppPage.tenOneP[3]') }}
            </p>
            <p>
              {{ $t('ppPage.tenOneP[4]') }}
            </p>
            <p>
              {{ $t('ppPage.tenOneP[5]') }}
            </p>
            <p>
              {{ $t('ppPage.tenOneP[6]') }}
            </p>
            <p>
              {{ $t('ppPage.tenOneP[7]') }}
            </p>
            <p>
              {{ $t('ppPage.tenOneP[8]') }}
            </p>
            <p>
              {{ $t('ppPage.tenOneP[9]') }}
            </p>

            <h5 class="mt-5">{{ $t('ppPage.tenTwoTitle') }}</h5>
            <p>
              {{ $t('ppPage.tenTwoP[0]') }}
            </p>
            <p>
              {{ $t('ppPage.tenTwoP[1]') }}
            </p>
            <p>
              {{ $t('ppPage.tenTwoP[2]') }}
            </p>
            <p>
              {{ $t('ppPage.tenTwoP[3]') }}
            </p>

            <h4 class="mt-5 text-uppercase">{{ $t('ppPage.elevenTitle') }}</h4>
            <p>
              {{ $t('ppPage.elevenP') }}
            </p>

            <h4 class="mt-5 text-uppercase">{{ $t('ppPage.twelveTitle') }}</h4>
            <p>
              {{ $t('ppPage.twelveP') }}
            </p>
          </div>
        </div>
      </div>
    </section>



    <footerJSK />
  </div>
</template>

<script>
import footerJSK from "./../components/footer.vue";
import navMenu from "./../components/navMenu.vue";
import hero from "./../components/hero.vue";

export default {
  name: "PrivacyPolicy",
  components: {
    navMenu,
    hero,
    footerJSK
  },
  mounted () {
    window.scrollTo(0, 0)
  }
};
</script>
